import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Floatingcall from "../components/floatingbutton/Floatingcall";
import { Helmet } from "react-helmet";
import LandingPageClient from "../components/ladingpageclient/LandingPageClient";

function PrivateSecurityServices(){

  const scrollToTop = () => {
    window.scrollTo(0, 0)
}

const testimonials = [
  {
    name: "Rahul Sharma",
    role: "Business Owner",
    feedback:
      "We needed private security for a short period. Helper Ji’s security personnel remained calm and professional and delivered their excellent service",
    image: "https://i.pravatar.cc/150?img=12",
  },
  {
    name: "Neha Verma",
    role: "Working Professional",
    feedback:
      "There was no unnecessary interference from Helper Ji’s security team, but their presence felt reassuring.",
    image: "https://i.pravatar.cc/150?img=32",
  },
  {
    name: "Amit Singh",
    role: "Corporate Manager",
    feedback:
      "The Helper Ji security staff stayed alert and handled movement carefully. The guards are very active and perform their best work.",
    image: "https://i.pravatar.cc/150?img=56",
  },
];

    return(
        <Fragment>
          <Helmet>
            <title>
          Personal Security Services | Professional Private Security Guards Services
        </title>

        <meta
          name="description"
          content="Hire professional private security services providing trained private security guards, personal security personnel & reliable security solutions for businesses & individuals near you."
        />

        <meta
          name="keywords"
          content="Private Security Services, Professional Private Security Services, Private Security Guards, Trained Private Security Guards, Personal Security Personnel, Private Security Manpower, Security Services Provider, Corporate Private Security Services, Private Security Solutions"
        />

        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta name="bingbot" content="index, follow" />
        <meta name="revisit-after" content="daily" />
        <meta name="allow-search" content="yes" />
        <meta name="copyright" content="Helper Ji" />

        {/* ===== CANONICAL ===== */}
        <link
          rel="canonical"
          href="https://www.helperji.in/private-security-services"
        />

        {/* ===== OPEN GRAPH ===== */}
        <meta
          property="og:title"
          content="Personal Security Services | Professional Private Security Guards Services"
        />
        <meta
          property="og:description"
          content="Hire professional private security services providing trained private security guards, personal security personnel & reliable security solutions for businesses & individuals near you."
        />
        <meta
          property="og:image"
          content="https://www.helperji.in/assets/img/security1.jpeg"
        />
        <meta property="og:site_name" content="Helper Ji" />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.helperji.in/private-security-services"
        />

        {/* ===== TWITTER META ===== */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@helperji_" />
        <meta name="twitter:creator" content="@helperji_" />
        <meta
          name="twitter:title"
          content="Personal Security Services | Professional Private Security Guards Services"
        />
        <meta
          name="twitter:description"
          content="Hire professional private security services providing trained private security guards, personal security personnel & reliable security solutions for businesses & individuals near you."
        />
        <meta
          name="twitter:image"
          content="https://www.helperji.in/assets/img/security1.jpeg"
        />

        {/* ===== WEBPAGE SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "url": "https://www.helperji.in/private-security-services",
            "name": "Personal Security Services | Professional Private Security Guards Services",
            "description": "Hire professional private security services providing trained private security guards, personal security personnel & reliable security solutions for businesses & individuals near you."
          }
          `}
        </script>

        {/* ===== PRODUCT SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": "Private Security Guard Services",
            "image": "https://www.helperji.in/assets/img/security1.jpeg",
            "description": "Hire professional private security services providing trained private security guards, personal security personnel & reliable security solutions for businesses & individuals near you.",
            "brand": {
              "@type": "Brand",
              "name": "Helper Ji"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.9",
              "ratingCount": "644"
            }
          }
          `}
        </script>

        {/* ===== BREADCRUMB SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.helperji.in"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Private Security Guard Services",
                "item": "https://www.helperji.in/private-security-services"
              }
            ]
          }
          `}
        </script>
          <script type="text/javascript">
    {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
  </script>
          </Helmet>
            
            <Floatingcall />
         
            <section id="about" class="about">
            <div class="container" data-aos="fade-up">

            <div class="section-header">
            <h2>Private Security Services</h2>
            <p>Personal Security Officer Services at Helper Ji </p>
             </div>

           <div class="row gy-4">
           <div class="col-lg-6">
            <img src="/assets/img/security1.jpeg" class="img-fluid rounded-4 mb-4" alt="" />
            
            </div>
          
          <div class="col-lg-6">
            <div class="content ps-0 ps-lg-5">
              <h3 class="fst-italic">
              With Helper Ji's Personal Security Officer Services, we ensure your safety
              </h3>
              <p className="text-justify">
              In today's dynamic and often unpredictable world, ensuring personal safety has become a primary concern for individuals from all walks of life. <b> <a href="https://www.helperji.in/private-security-services">PSO Security Services</a> </b> offer a comprehensive solution to these concerns, providing dedicated professionals trained to safeguard clients against potential threats and risks. The security solutions Helper Ji provides are designed to meet each client's specific needs.
              </p>
              <p className="text-justify">We provide high-quality security solutions at an affordable price regardless of geographical location, owing to our extensive network of highly trained personal security guards effectively positioned nationwide. You can live life with confidence and security wherever you are with Helper Ji, as we provide comprehensive security and protection.</p>
              <p className="text-justify">Then why hesitate, take advantage of our <a href="https://www.helperji.in/">Helper Ji</a> <b><a href="https://www.helperji.in/private-security-services">personal security services</a></b>, and become completely tension-free. Now that we are here, there is no need to fear.</p>
            </div>
          </div>
        </div>

      </div>
    </section>

    <section id="services" class="services sections-bg">
          <div class="container" data-aos="fade-up">
    
            <div class="row gy-4">
              
              <div class="col-lg-6">
                <div class="content ps-0 ps-lg-5">
                  <h2>
                  Why Choose Helperji's Private Security Services:
                  </h2>
                  <p className="text-justify">
                  When it comes to your security, choosing Helper Ji is a decision backed by several compelling reasons. As one of the top providers of armed security services, we provide a range of services. Our team is unmatched in skill and proficiency.
                  </p>
                  <p className="text-justify">We prioritize your needs and concerns above all else, ensuring that you receive personalized attention and solutions tailored to your specific requirements. Let Helper Ji take care of your security needs.</p>
                  <p className="text-justify">Each member of our private security guard team undergoes extensive security training and education to ensure your safety. Utilizing the most recent technology enhances the quality of our services. A cutting-edge surveillance system and communication tool keep you safe and secure. Finally, our dedication to client satisfaction is never-ending. </p>
                  
                  <div class="text-center"><Link to='/contact-us' className="booknow" onClick={scrollToTop}>Book Now</Link></div>
                </div>
              </div>
              <div class="col-lg-6">
                <img src="/assets/img/security2.jpg" class="img-fluid rounded-4 mb-4" alt="" />
                
              </div>
            </div>
    
          </div>
        </section>

          <section className="py-5 bg-white">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">What Our <span style={{ color: "#ED1C24" }}>Clients Say</span> </h2>
          <p className="text-muted">
            Trusted by thousands of satisfied customers
          </p>
        </div>

        {/* Testimonials */}
        <div className="row g-4">
          {testimonials.map((item, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="card bg-light h-100 shadow-sm border-0 text-center p-4">
                <img
                  src={item.image}
                  alt={item.name}
                  className="rounded-circle mx-auto mb-3"
                  width="90"
                  height="90"
                />

                <p className="text-muted fst-italic">
                  “{item.feedback}”
                </p>

                <h5 className="fw-semibold mb-0">{item.name}</h5>
                <small className="text-danger">{item.role}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

        <section id="services" class="services sections-bg">
        <div className="container">
          <h3 className="pb-4">
            Private Security Services – FAQs
          </h3>
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                What is the difference between security guard services and private security services?
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Private security services focus on personal protection and discreet security, while regular guards handle premises security.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  For how long can private security services be hired?
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Private security can be arranged for short-term or long-term needs, including events, travel, or residential protection.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                 Are private security personnel professionally trained?
                </button>
              </h2>
              <div
                id="flush-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingThree"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, private security staff are trained in personal safety, situational awareness, and controlled response.
                </div>
              </div>
            </div>
             <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFour"
                  aria-expanded="false"
                  aria-controls="flush-collapseFour"
                >
                  Will the security personnel interfere in personal matters?
                </button>
              </h2>
              <div
                id="flush-collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFour"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 No, Helper Ji’s private security staff maintains professionalism and avoids unnecessary involvement.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFive"
                  aria-expanded="false"
                  aria-controls="flush-collapseFive"
                >
                  Is private security available for families as well as individuals?
                </button>
              </h2>
              <div
                id="flush-collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFive"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
               Yes, services can be provided for individuals, families, and private residences.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

       <LandingPageClient />
        </Fragment>
    )
}

export default PrivateSecurityServices;